export const riskyPrefixes = [
    // Original prefixes
    '+881',  // Satellite numbers
    '+882',  // Satellite services
    '+883',  // Satellite services
    '+870',  // Inmarsat
    '+899',  // International premium numbers
    '+2208', // Gambia - known high risk
    '+234',  // Nigeria - parts high risk
    '+92',   // Pakistan - parts
    '+963',  // Syria
    '+964',  // Iraq
    '+967',  // Yemen
    '+850',  // North Korea
    '+9715', // UAE premium mobile numbers
    '+7',    // Russia - parts high risk
    
    // Additional high-risk prefixes by region
    
    // Africa
    '+225',  // Côte d'Ivoire
    '+229',  // Benin
    '+232',  // Sierra Leone
    '+237',  // Cameroon
    '+240',  // Equatorial Guinea
    '+243',  // Democratic Republic of Congo
    '+244',  // Angola
    '+252',  // Somalia
    '+256',  // Uganda
    
    // Asia & Middle East
    '+886',  // Taiwan - some premium services
    '+95',   // Myanmar
    '+960',  // Maldives
    '+966',  // Saudi Arabia - some premium services
    '+972',  // Israel - some premium services
    '+973',  // Bahrain - some premium services
    '+977',  // Nepal
    '+994',  // Azerbaijan
    '+998',  // Uzbekistan
    
    // Americas
    '+1242', // Bahamas
    '+1246', // Barbados
    '+1264', // Anguilla
    '+1268', // Antigua and Barbuda
    '+1284', // British Virgin Islands
    '+1345', // Cayman Islands
    '+1441', // Bermuda
    '+1473', // Grenada
    '+1649', // Turks and Caicos Islands
    '+1664', // Montserrat
    '+1767', // Dominica
    '+1784', // Saint Vincent and the Grenadines
    '+1809', // Dominican Republic
    '+1829', // Dominican Republic
    '+1849', // Dominican Republic
    '+1868', // Trinidad and Tobago
    '+1869', // Saint Kitts and Nevis
    '+1876', // Jamaica
    '+53',   // Cuba
    '+509',  // Haiti
    
    // Europe
    '+355',  // Albania
    '+373',  // Moldova
    '+374',  // Armenia
    '+375',  // Belarus
    '+380',  // Ukraine - some premium services
    '+3909', // Italy - premium services
    '+4484', // UK - premium services
    '+4487', // UK - premium services
    '+4613', // Sweden - premium rate
    '+4618', // Sweden - premium rate
    '+48700', // Poland - premium services
    '+4990', // Germany - premium services
    
    // Premium rate and special services
    '+5399', // Cuba - premium
    '+682',  // Cook Islands - high international rates
    '+683',  // Niue - high international rates
    '+685',  // Samoa - high international rates
    '+688',  // Tuvalu - high international rates
    '+7809', // Kazakhstan - premium
    '+809',  // Caribbean - premium
    '+878',  // Universal Personal Telecommunications
    '+900',  // Premium rate services (multiple countries)
    '+901',  // Global premium services
    '+906',  // Global premium services
    '+976',  // Mongolia - known fraud risks
  ];